import React, { useState } from 'react'
import axios from "axios"
import { useNavigate } from 'react-router-dom'
import "./style/Singup.css"

export default function Singup() {
    const navigate = useNavigate()
    const api = "https://mkbackend-production.up.railway.app"
    //mkbackend-production.up.railway.app
    const [singup, setSingup] = useState({
        email: "",
        password: "",
        cpassword: "",
        otp: ""
    })
    const [otpSent, setOtpSent] = useState(false)

    const handleChange = (e) => {
        setSingup({
            ...singup,
            [e.target.name]: e.target.value
        })
    }

    const sendOtp = async () => {
        try {
            await axios.post(`${api}/send-otp`, {
                email: singup.email
            })
            alert("OTP Sent To Your Email")
            setOtpSent(true)
        } catch (error) {
             alert(error.response?.data?.message || 'Failed to send OTP')
            console.error(error.message)
        }
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            const res = await axios.post(
                `${api}/verify-otp`,
                {
                    email: singup.email,
                    password: singup.password,
                    cpassword: singup.cpassword,
                    otp: singup.otp
                }
            )

            alert(res.data.message)
            
            // Store user data in localStorage
            if (res.data.user) {
                localStorage.setItem('token', res.data.token || 'dummy-token')
                localStorage.setItem('shop', JSON.stringify(res.data.user))
                // Navigate to dashboard or home
                navigate('/')
            }

        } catch (error) {
            console.error(error.message)
            alert(error.response?.data?.message || 'Registration failed')
        }
    }

    return (
        <div className='singup'>
            <h1>Sign Up</h1>
            <form onSubmit={handleSubmit}>
                <p>Email</p>
                <input
                    type="email"
                    placeholder='Enter Email'
                    onChange={handleChange}
                    name='email'
                    required
                />

                <button type='button' onClick={sendOtp}>
                    Send OTP
                </button>

                {otpSent && (
                    <>
                        <p>Enter OTP</p>
                        <input
                            type="text"
                            placeholder='Enter OTP'
                            onChange={handleChange}
                            name='otp'
                            required
                        />
                    </>
                )}

                <p>Password</p>
                <input
                    type="password"
                    placeholder='Enter Password'
                    onChange={handleChange}
                    name='password'
                    required
                />

                <p>Confirm Password</p>
                <input
                    type="password"
                    placeholder='Enter same password again'
                    onChange={handleChange}
                    name='cpassword'
                    required
                />

                <button type='submit'>Register</button>
            </form>
        </div>
    )
}